import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, SecurityContext } from '@angular/core';
import { environment } from 'src/app/environments/environment';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { ExcelExportReportInputs } from '../../models/excel-export-report.model';
import { SharedPopupService } from '../../services/shared-popup.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-header-settings',
  templateUrl: './header-settings.component.html',
  styleUrls: ['./header-settings.component.css']
})
export class HeaderSettingsComponent implements OnInit {
showClearAll: boolean = false;
  triggerNew: boolean = false;
  toggleSetting: boolean = false;
  @Input() settingIconShown: boolean = true;
  @Input() helpGuide: boolean = false;
  @Input() showExcel: boolean = false;
  @Input() showPPT: boolean = false;
  @Input() excelExport: boolean = false;
  @Input() pptExport: boolean = false;
  @Input() repository: boolean = false;
  @Input() exportDownloads: boolean = false;
  @Input() userManagementShown: boolean = false;
  @Input() lowBaseIdentifier: boolean = false;
  @Input() exportReportInput!: ExcelExportReportInputs;
  @Input() logout:boolean=true;
  @Input() Home:boolean=true;
  @Input() isHeader:boolean=true;
  @Input() moduleName: string = '';
  isUserManagement:boolean=false;
  guideUrl = environment.UserGuideUrl;
  receivedBoolValue: boolean = false;
  showExportsDownloadsPopup: boolean = false;
  @Output() excelExportClick = new EventEmitter<void>();
  @Output() pptExportClick = new EventEmitter<void>();
  @Output() documentRepoClick = new EventEmitter<void>();
  @Output() OnSettingsSel = new EventEmitter<string>();
 

notifications: any[] = [];

showNotification: boolean = false;
  @Input() docClick: boolean = true;
  @Input() hasDocuments: boolean = false;
  notificationCount: any;
  constructor(private router: Router, private el: ElementRef, private _authenticateService: AuthenticationService,private sharedPopup:SharedPopupService,private sanitizer: DomSanitizer) { }
  ngOnInit(): void {
   
    let accessLevel = this._authenticateService.GetAccess();
    if (accessLevel != null) {
      if (accessLevel == this._authenticateService.level1 || accessLevel == this._authenticateService.level2) {
        this.isUserManagement = true;
      }
    }
 
  }


  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    // Check if the clicked element is outside the component
    if (!this.el.nativeElement.contains(event.target)) {
      this.toggleSetting = false;
    }
  }
  getSanitizedHtml(html: string): SafeHtml {
  return this.sanitizer.sanitize(SecurityContext.HTML, html) || '';
}
stripHtml(text: string): string {
  return text.replace(/<[^>]*>/g, '');
}
onNotificationClick(notification: any, event: MouseEvent): void {
    const target = event.target as HTMLElement;
    // don't toggle when clicking interactive elements (checkbox, link, button, label, etc.)
    if (target.closest('input, a, button, label, select, textarea')) {
      return;
    }
    notification.checked = !notification.checked;
  }
  redirectToLandingPage() {
    this.router.navigate(['/landing']);
  }
  onUserManagementClick() {
    this.router.navigate(['/user-management']);
  }
  OnSettingClick() {
    this.toggleSetting = !this.toggleSetting;
  }
  OnClickExcelExport() {
    this.excelExportClick.emit();
    this.toggleSetting = false;
  }
  onUserGuideClick() {
    const guideUrl = this.guideUrl;
    window.open(guideUrl, '_blank');
  }
  OnExportsDownloads() {
    this.showExportsDownloadsPopup = true;
  }
  onCloseExportDownloads() {
    this.showExportsDownloadsPopup = false;
  }

  HandleDocumentClick() {
    this.documentRepoClick.emit();
    this.toggleSetting = false;
  }
toggleNotification() {
   let study = localStorage.getItem('selectedStudy') ?? '';
    let client = localStorage.getItem('selectedClient') ?? '';
    let userEmail = localStorage.getItem('useremail') ?? '';
    this.sharedPopup.getTriggeredAlertList(userEmail, client, study).subscribe((value: any) => {
     
      const parsedData = JSON.parse(value.Data);
      console.log('Received value from service:', parsedData);
      
       if (parsedData.TriggeredAlerts && parsedData.TriggeredAlerts.items && Array.isArray(parsedData.TriggeredAlerts.items)) {
        this.notifications = parsedData.TriggeredAlerts.items.map((alert: any) => ({
          header: alert.AlertName,
          alertId: alert.AlertId,
          text: alert.desc,
         
           checked: false,
           
        }));
      }
      this.notificationCount = parsedData.TriggeredAlerts.totalCount || 0;
       this.showNotification = !this.showNotification;
      this.showClearAll=true;
      this.triggerNew=true;
    });
  }
  ExportToPPT() {
    this.pptExportClick.emit();
    this.toggleSetting = false;
  }
  LogOut() {
    this._authenticateService.logout();
  }

  settingOptionSel(item : any){
    this.toggleSetting = false;
    this.OnSettingsSel.emit(item);
  }

clearAll(checkedNotifications: any[]) {
  // Extract alert IDs from checked notifications
  const alertIds = checkedNotifications.map(notification => notification.alertId);
  

  
  // Remove notifications with matching alert IDs
  this.notifications = this.notifications.filter(
    notification => !alertIds.includes(notification.alertId)
  );
  

  
  // Update notification count
  this.notificationCount = this.notifications.length;
  
  this.sharedPopup.updateTriggeredAlertList(alertIds).subscribe(
    (response: any) => {
      
      if (this.notifications.length === 0) {
        this.showNotification = false;
        this.triggerNew = false;
      }
    },
    (error: any) => {
      console.error('Error clearing alerts:', error);
    }
  );
}
}
